// @flow
import type { ExperimentInfo } from 'pages/MyAccount/services/reducers/customizeReducer';

export const CUSTOMIZE = {
  REQUEST_LAST_QUESTION: 'customize/request_last_question',
  RECEIVE_LAST_QUESTION_SUCCESS: 'customize/receive_last_question_success',
  RECEIVE_LAST_QUESTION_ERROR: 'customize/receive_last_question_error',
};

export type RequestCustomizeLastQuestionAction = {
  type: typeof CUSTOMIZE.REQUEST_LAST_QUESTION,
};

export type ReceiveCustomizeLastQuestionAction = {
  type: typeof CUSTOMIZE.RECEIVE_LAST_QUESTION_SUCCESS,
  lastQuestionId: number,
};

export type ReceiveCustomizeLastQuestionErrorAction = {
  type: typeof CUSTOMIZE.RECEIVE_LAST_QUESTION_ERROR,
  error: string,
};

export function requestCustomizeLastQuestion(): RequestCustomizeLastQuestionAction {
  return {
    type: CUSTOMIZE.REQUEST_LAST_QUESTION,
  };
}

export function receiveCustomizeLastQuestion(
  lastQuestionId: number,
  experimentInfo: ExperimentInfo,
): ReceiveCustomizeLastQuestionAction {
  return {
    type: CUSTOMIZE.RECEIVE_LAST_QUESTION_SUCCESS,
    lastQuestionId,
    experimentInfo,
  };
}

export function receiveCustomizeLastQuestionError(
  error: string,
): ReceiveCustomizeLastQuestionErrorAction {
  return {
    type: CUSTOMIZE.RECEIVE_LAST_QUESTION_ERROR,
    error,
  };
}
